import React, { useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';

function Header() {
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
    const [activeDropdown, setActiveDropdown] = useState<string | null>(null);
    const [activeProductRoadMapDropdown, setActiveProductRoadMapDropdown] = useState<string | null>(null);

    const toggleMobileMenu = () => {
        document.querySelector('body')?.classList.toggle('mobile-nav-active');
        setMobileMenuOpen(!mobileMenuOpen);
    };

    const closeMobileMenu = () => {
        document.querySelector('body')?.classList.remove('mobile-nav-active');
        setMobileMenuOpen(false);
    };

    const toggleDropdown = (dropdownName: string) => {
        setActiveDropdown(activeDropdown === dropdownName ? null : dropdownName);
    };
    const toggleProductRoadMapDropdown = (productName: string) => {
        setActiveProductRoadMapDropdown(activeProductRoadMapDropdown === productName ? null : productName);
    };

    /*const isActive = (path: string) => {
        return location.pathname === path;
    };*/

    return (
        <header id="header" className="header d-flex align-items-center sticky-top">
            <div className="container position-relative d-flex align-items-center justify-content-between">
                <Link to="/" className="logo d-flex align-items-center me-auto me-xl-0">
                    <h1 className="sitename">M365Insights.net</h1>
                </Link>

                <nav id="navmenu" className={`navmenu ${mobileMenuOpen ? 'mobile-nav-active active' : ''}`}>
                    <ul>
                        <li>
                            <NavLink to="/calendar" className={({ isActive }) => isActive ? 'active' : ''} onClick={() => closeMobileMenu()}>
                                Events
                            </NavLink>
                        </li>
                        <li>
                            <NavLink to="/blogs" className={({ isActive }) => isActive ? 'active' : ''} onClick={() => closeMobileMenu()}>
                                Blogs
                            </NavLink>
                        </li>
                        <li>
                            <NavLink to="/aiblog" className={({ isActive }) => isActive ? 'active' : ''} onClick={() => closeMobileMenu()}>
                                AI Blog
                            </NavLink>
                        </li>                        
                         {/* <li>
                            <NavLink to="/showcase" className={({ isActive }) => isActive ? 'active' : ''} onClick={() => closeMobileMenu()}>
                                Copilot Apps
                            </NavLink>
                        </li>*/}
                        <li>
                            <NavLink to="/videoarchive" className={({ isActive }) => isActive ? 'active' : ''} onClick={() => closeMobileMenu()}>
                                Video Archive
                            </NavLink>
                        </li>                        
                        <li className={`dropdown`}>
                            <a 
                                href="#" 
                                className={`dropdown ${activeDropdown === 'categories' ? 'active' : ''}`}
                                onClick={(e) => {
                                    e.preventDefault();
                                    toggleDropdown('categories');
                                }}
                            >
                                <span>M365 Roadmap</span> 
                                <i className="bi bi-chevron-down toggle-dropdown"></i>
                            </a>
                            <ul className={`dropdown ${activeDropdown === 'categories' ? 'dropdown-active' : ''}`}>
                                <li>
                                    <Link to="/m365updates">Roadmap overview</Link>
                                </li>
                                {[
                                    'SharePoint',                                    
                                    'SharePoint Syntex',                                    
                                    'Microsoft Search', 
                                    'Microsoft Viva',
                                    'Microsoft Stream',
                                    'Microsoft Teams',                                    
                                    'Microsoft To Do',
                                    'Microsoft Project',
                                    'Office 365',                                     
                                    'Microsoft 365 Admin Center',                                    
                                    'Microsoft 365',
                                    'Microsoft Entra',                                    
                                    'Microsoft 365 Defender',                                    
                                    'Microsoft Purview',                                                                                 
                                    'Microsoft Intune'                                    
                                ].map((productName) => (
                                    <li key={productName} className={`dropdown`}>
                                        <a 
                                        href="#" 
                                        className={`${activeProductRoadMapDropdown === productName ? 'active' : ''}`}
                                        onClick={(e) => {                                            
                                            e.preventDefault();
                                            toggleProductRoadMapDropdown(productName);
                                        }}
                                    >
                                        <span>{productName}</span> 
                                        <i className="bi bi-chevron-down toggle-dropdown"></i>
                                    </a>                                    
                                    <ul className={`dropdown ${activeProductRoadMapDropdown === productName ? 'dropdown-active' : ''}`}>
                                        {[
                                            'Rolling out',
                                            'Launched',
                                            'In development',
                                            'Cancelled'
                                        ].map((status) => (
                                            <li key={status}>
                                                <Link
                                                    to={`/m365updates?status=${encodeURIComponent(status)}&product=SharePoint`}
                                                    onClick={() => closeMobileMenu()}
                                                >
                                                    {status}
                                                </Link>
                                            </li>
                                        ))}
                                    </ul>
                                    </li>
                                ))}


                            </ul>
                        </li>
                        <li>
                            <NavLink to="/contact" className={({ isActive }) => isActive ? 'active' : ''} onClick={() => closeMobileMenu()}>
                                Contact
                            </NavLink>
                        </li>
                        <li>
                            <NavLink to="/about" className={({ isActive }) => isActive ? 'active' : ''} onClick={() => closeMobileMenu()}>
                                About
                            </NavLink>
                        </li>                        
                    </ul>
                    <i 
                        className={`mobile-nav-toggle d-xl-none bi ${mobileMenuOpen ? 'bi-x' : 'bi-list'}`}
                        onClick={toggleMobileMenu}
                    ></i>
                </nav>

                <div className="header-social-links">
                    <a href="https://twitter.com/marcandrezhou" className="twitter" aria-label="Twitter">
                        <i className="bi bi-twitter-x"></i>
                    </a>
                    <a href="https://www.youtube.com/channel/UCvVuOjixE050egnWNcoSZ-Q?app=desktop" className="youtube" aria-label="Youtube">
                        <i className="bi bi-youtube"></i>
                    </a>
                    <a href="https://www.dev-sky.net/blog.html" className="instagram" aria-label="Instagram">
                        <i className="bi bi-newspaper"></i>
                    </a>
                    <a href="https://www.linkedin.com/in/dev-schroeder/" className="linkedin" aria-label="LinkedIn">
                        <i className="bi bi-linkedin"></i>
                    </a>
                </div>
            </div>
        </header>
    );
}

export default Header;
